export interface Column {
  label: string,
  key: string,
  type: 'string' | 'number' | 'date',
  field: string
}

export const COLUMNS: Column[] = [
  {
    label: 'Property Sub-Type',
    key: 'property_sub_type',
    type: 'string',
    field: 'propertySubTypeName'
  },
  {
    label: 'Building Name / Number',
    key: 'building_name',
    type: 'string',
    field: 'buildingName'
  },
  {
    label: 'Street',
    key: 'street',
    type: 'string',
    field: 'street'
  },
  {
    label: 'Community',
    key: 'community',
    type: 'string',
    field: 'communityName'
  },
  {
    label: 'Address',
    key: 'address',
    type: 'string',
    field: 'address'
  },
  {
    label: 'Bedrooms',
    key: 'bedrooms',
    type: 'number',
    field: 'bedrooms'
  },
  {
    label: 'BUA',
    key: 'size',
    type: 'number',
    field: 'size'
  },
  {
    label: 'Total Price',
    key: 'price',
    type: 'number',
    field: 'price'
  },
  {
    label: 'Price on BUA',
    key: 'price_per_size',
    type: 'number',
    field: 'pricePerSize'
  },
  {
    label: 'Transaction type',
    key: 'transaction_type',
    type: 'string',
    field: 'transactionType'
  },
  {
    label: 'Date',
    key: 'date',
    type: 'date',
    field: 'sourceDate'
  },
  {
    label: 'Offer',
    key: 'offer',
    type: 'string',
    field: 'offerType'
  }
]

export const DISPLAYED_COLUMNS = ['index', ...COLUMNS.map(column => column.key), 'action']
